import { render, staticRenderFns } from "./offers-demands-form.html?vue&type=template&id=2cc23386&"
import script from "./offers-demands-form.ts?vue&type=script&lang=js&"
export * from "./offers-demands-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports